import React from "react";
import ConditionExpressionManager from './Tabs/ConditionExpressionManager';
import Collapse from 'react-bootstrap/Collapse';
import {
  FILTERING_CONDITIONAL
} from '../shared/constants/app_constants';

export default class FilteringConditionalsEditor extends React.Component{

  getNewConditionExpression(){
    return {
      index: undefined,
      id: undefined,
      _destroy: false,

      operand1_uuid: undefined, // are we using this anymore? I dont think so
      operand1_value_type: undefined,
      operator: undefined,
      operand2_pre_type: undefined
    };
  }

  deleteConditional = (index) => {
    console.log('delete this filtering conditional - ', index);
    console.log(this.props);
    this.props.deleteConditional(index);
  }

  /**
   * return an array of target attribute names
   */
  getTargetAttributeNames(){
    let targetAttributeNames = [];
    this.props.form_rule.target_attribute_ids.forEach(target_attribute_id => {
      const targetAttribute = this.props.keenform.form_attributes.find(fa => fa.id === target_attribute_id);
      targetAttributeNames.push(targetAttribute.name);
    });
    return targetAttributeNames;
  }

  setJoiner = (joinerType) => {
    this.props.updateFormRuleAttributePerParams("dynamic_filtering_joiner", joinerType);
  }

  // TODO: might need to refactor this - change the name to updateFormRuleConditionals
  updateConditionExpression = (conditional) => { //TODO: need to work on this
    let updatedConditional = {...conditional};

    // get copy of conditionExpressionList
    let filteringConditionalsArray = [...this.props.form_rule.filtering_conditionals];

    //get operand1 form attribute uuid
    const updatedFAUUID = updatedConditional.operand1_uuid;
    let formAttribute;
    if (updatedFAUUID !== undefined){
      formAttribute = this.props.keenform.form_attributes.find(fa => fa.uuid === updatedFAUUID);
    }

    // verify if the form attribute for operand1 has been updated
    // TODO: this is a source of a bug, as of 2020.09.22 might be fixed
    // const conditionalToBeUpdated = formRuleConditionalsArray[updatedCondition.index]; // this isnt working, index is not there
    const operand1Modified = filteringConditionalsArray[updatedConditional.index].operand1_uuid !== updatedConditional.operand1_uuid;

    filteringConditionalsArray[updatedConditional.index] = updatedConditional;
    
    //TODO update this 
    this.props.updateFormRuleAttributePerParams("filtering_conditionals", filteringConditionalsArray);
  }

  render() {
    const form_rule = this.props.form_rule;
    const filtering_conditionals = form_rule.filtering_conditionals.map((conditional, index) => {
      return {
        ...conditional,
        index
      }
    });
    const activeConditionalsCount = filtering_conditionals.filter(c => !c._destroy).length;
    return (<React.Fragment>

      <div className="container">
        <div className="form-group row">
          <div className="col">
            <div className="alert alert-info" role="alert">
              Conditions provides a way to add logic so that rules can run <i>conditionally</i>
            </div>
          </div>
        </div>

        <Collapse in={filtering_conditionals.length > 1}>
          <div className={`col-md-4 text-right`}>
            <div className="btn-group" role="group" aria-label="form_rule_dynamic_filtering_joiner">
              <button 
                type="button"
                onClick={() => {this.setJoiner('AND')}}
                className={`btn btn-outline-primary ${this.props.form_rule.dynamic_filtering_joiner === 'AND' ? 'active' : ''}`}>AND</button>
              <button 
                type="button"
                onClick={() => {this.setJoiner('OR')}}
                className={`btn btn-outline-primary ${this.props.form_rule.dynamic_filtering_joiner === 'OR' ? 'active' : ''}`}>OR</button>
            </div>
            <input 
              type="hidden"
              name="form_rule[dynamic_filtering_joiner]"
              value={this.props.form_rule.dynamic_filtering_joiner} />
          </div>
        </Collapse>

        <div className="form-group row">
          <div className="col-12">
            <div className="condition-list">
              { filtering_conditionals.map((conditional, index) => {
                  const lastRow     = ( index === (filtering_conditionals.length-1)),
                      disableDelete = ( activeConditionalsCount === 1 || conditional._destroy),
                      rowClass      = ( conditional._destroy ? 'd-none' : 'row condition-item');
                  return (<React.Fragment key={`frag-${index}`}>
                    <div key={`condition-${index}`} className={rowClass}>
                      <div className="col-md-10">
                        <ConditionExpressionManager
                          conditional={conditional}
                          conditional_type={FILTERING_CONDITIONAL}
                          keenform={this.props.keenform}
                          form_rule={form_rule}
                          onUpdateAction={this.updateConditionExpression}
                          index={index} />
                      </div>
                      <div className="col-md-2 text-right">
                        <button
                          onClick={() => {this.deleteConditional(index)}}
                          className="btn btn-danger btn-circle"
                          disabled={disableDelete}
                          type="button">
                            <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>
                    { lastRow ? undefined :
                      <div className="row">
                        <div className="col">
                          <span className="badge badge-info badge-pill">{this.props.form_rule.dynamic_filtering_joiner}</span>
                        </div>
                      </div>
                    }
                  </React.Fragment>);
                })
              }
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6" />
          <div className="col-6 text-right">
            <button
              onClick={() => {this.props.addNewCondition()}}
              className={`btn btn-success invisible'}`}
              disabled={false}
              type="button">
                <i className="fa fa-plus"></i> ADD CONDITION
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>);
  }
}